import React from 'react'
import { MenuList, MenuItem } from '@mui/material'
import { MENU_SETTINGS_OPTIONS } from '../../helpers/options/options'
import { useTranslation } from 'react-i18next'

interface MenuSettingsProps {
  handleOptionClick: (to: string) => void
}

const MenuDesktopSettings = ({ handleOptionClick }: MenuSettingsProps) => {
  const { t } = useTranslation()

  return (
    <MenuList className="vertical-menu">
      {MENU_SETTINGS_OPTIONS.map((value, index) => {
        return (
          <MenuItem
            id={`MenuItem-${index}-circle`}
            key={`MenuItem-${index}`}
            className="menu-logged-settings-principal"
          >
            {`${t(value.principal_label)}`}
            {value.sub_options.map((val, ind) => {
              return (
                <MenuItem
                  id={`MenuItem-${ind}-circle`}
                  key={`MenuItem-${ind}`}
                  className="menu-logged-settings"
                  onClick={() => handleOptionClick(val.to)}
                >
                  {`${t(val.label)}`}
                </MenuItem>
              )
            })}
          </MenuItem>
        )
      })}
    </MenuList>
  )
}

export default MenuDesktopSettings
